import React from "react";
import { Link } from "react-router-dom";

function Privacy_header(){

    return(
        <div className="privacy-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>حریم خصوصی</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">حریم خصوصی</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Privacy_header;